import React from 'react';
import { X, Check } from 'lucide-react';
export function BeforeAfter() {
  return <section className="py-8 px-4 bg-purple-50/30" data-id="element-18">
      <div className="max-w-4xl mx-auto" data-id="element-19">
        <h2 className="text-3xl font-bold text-center mb-6" data-id="element-20">
          🔄 Antes vs Después
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-21">
          {/* Antes */}
          <div className="bg-red-50 p-6 rounded-2xl border-2 border-red-100" data-id="element-22">
            <h3 className="text-2xl font-bold text-red-600 mb-3 flex items-center gap-2" data-id="element-23">
              <X className="w-8 h-8" data-id="element-24" /> Antes
            </h3>
            <ul className="space-y-2" data-id="element-25">
              <li className="flex items-center gap-3 text-gray-700" data-id="element-26">
                <span className="w-2 h-2 bg-red-400 rounded-full" data-id="element-27"></span>
                Rutina automática
              </li>
              <li className="flex items-center gap-3 text-gray-700" data-id="element-28">
                <span className="w-2 h-2 bg-red-400 rounded-full" data-id="element-29"></span>
                Pantallas constantes
              </li>
              <li className="flex items-center gap-3 text-gray-700" data-id="element-30">
                <span className="w-2 h-2 bg-red-400 rounded-full" data-id="element-31"></span>
                Poco diálogo
              </li>
              <li className="flex items-center gap-3 text-gray-700" data-id="element-32">
                <span className="w-2 h-2 bg-red-400 rounded-full" data-id="element-33"></span>
                Culpa silenciosa
              </li>
            </ul>
          </div>

          {/* Después */}
          <div className="bg-green-50 p-6 rounded-2xl border-2 border-green-100 shadow-lg transform md:scale-105" data-id="element-34">
            <h3 className="text-2xl font-bold text-green-600 mb-3 flex items-center gap-2" data-id="element-35">
              <Check className="w-8 h-8" data-id="element-36" /> Después
            </h3>
            <ul className="space-y-2" data-id="element-37">
              <li className="flex items-center gap-3 text-gray-800 font-medium" data-id="element-38">
                <Check className="w-5 h-5 text-green-500" data-id="element-39" />
                Momentos reales
              </li>
              <li className="flex items-center gap-3 text-gray-800 font-medium" data-id="element-40">
                <Check className="w-5 h-5 text-green-500" data-id="element-41" />
                Risas y charlas
              </li>
              <li className="flex items-center gap-3 text-gray-800 font-medium" data-id="element-42">
                <Check className="w-5 h-5 text-green-500" data-id="element-43" />
                Más conexión
              </li>
              <li className="flex items-center gap-3 text-gray-800 font-medium" data-id="element-44">
                <Check className="w-5 h-5 text-green-500" data-id="element-45" />
                Tranquilidad emocional
              </li>
              <li className="flex items-center gap-3 text-gray-800 font-medium" data-id="element-46">
                <Check className="w-5 h-5 text-green-500" data-id="element-47" />
                Recuerdos que quedan
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}